import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClockError(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <linearGradient
        id="clock-error_svg__b"
        x1={88}
        x2={88}
        y1={10}
        y2={110}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.195} stopColor="#f9e1e1" />
        <stop offset={1} stopColor="#f6f3f1" />
      </linearGradient>
      <clipPath id="clock-error_svg__a">
        <rect width={100} height={100} x={37.5} y={10} rx={50} />
      </clipPath>
      <g clipPath="url(#clock-error_svg__a)">
        <circle cx={88} cy={60} r={50} stroke="url(#clock-error_svg__b)" strokeWidth={20} />
      </g>
      <path stroke="#0c1c43" strokeLinecap="round" strokeLinejoin="round" d="M88 32v28l15-16" />
      <rect width={39} height={39} x={29.5} y={10.5} fill="#b01921" rx={19.5} />
      <g stroke="#fff">
        <rect width={39} height={39} x={29.5} y={10.5} rx={19.5} />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.51} d="M49 24v7m0 3v1" />
      </g>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClockError);
export default ForwardRef;
